// extracted by mini-css-extract-plugin
export var avatar = "_si-3";
export var avatarContainer = "_si-2";
export var avatarSpacer = "_si-5";
export var avatarSpacerContainer = "_si-4";
export var avatarStackContainer = "_si-1";
export var bubble = "_si-0";
export var remainderBubble = "_si-6";